import { useEffect } from "react";
import Cookies from "js-cookie";
import { getPrimaryDomain } from "@/react/helpers/urlHelpers/currentDomain";
import { UTM_PARAMS_COOKIE } from "@circle-react/components/OnboardingPage/helpers/constants";

export const useStoreUtmParams = () => {
  useEffect(() => {
    const params = new URLSearchParams(location.search);

    const decodeBase64 = str => {
      try {
        return decodeURIComponent(escape(window.atob(str)));
      } catch (e) {
        return null;
      }
    };

    let utmParams = {
      utm_source: params.get("utm_source"),
      utm_referrer: params.get("utm_referrer"),
      utm_medium: params.get("utm_medium"),
      utm_campaign: params.get("utm_campaign"),
      utm_term: params.get("utm_term"),
      utm_content: params.get("utm_content"),
      original_url:
        decodeBase64(params.get("original_url")) || window.location.href,
      referrer_url:
        decodeBase64(params.get("referrer_url")) || document.referrer,
      conversion_url: decodeBase64(params.get("conversion_url")),
      conversion_button: params.get("conversion_button"),
    };

    // Filter out any parameters that are null
    utmParams = Object.fromEntries(
      Object.entries(utmParams).filter(([, value]) => value !== null),
    );

    // If all parameters are null, don't set the cookie
    if (Object.keys(utmParams).length > 0) {
      Cookies.set(UTM_PARAMS_COOKIE, JSON.stringify(utmParams), {
        expires: 1,
        path: "/",
        domain: "." + getPrimaryDomain(location.hostname),
      });
    }
  }, []);
};
